import * as R from 'ramda';
import { connect } from 'react-redux';
import { lazy, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
// components
import { AppLayout } from '../components';
// constants
import * as C from '../constants';
// feature auth
import { loginRoutine } from '../features/auth/routines';
import { makeSelectLoggedIn } from '../features/auth/selectors';
// utilities
import * as U from '../utilities';
// router
import { changeRouteRoutine } from './routines';
////////////////////////////////////////////////

const routes = [
  C.ROUTE_PATH_HOME,
  C.ROUTE_PATH_LOGIN,
  C.ROUTE_PATH_NOT_FOUND,
];

const Login = lazy(() => import('../features/auth'));
const Board = lazy(() => import('../features/board'));
const NotFound = lazy(() => import('../components/notfound'));

const ProtectedRoute = ({ loggedIn }) => (loggedIn ? (
  <AppLayout />
) : (
  <Navigate to={C.ROUTE_PATH_LOGIN} />
));

const CustomRoutes = ({ loggedIn, changeRouteRoutine }) => {
  const location = useLocation();

  useEffect(() => {
    const path = U.getCurrentPathname(routes);

    if (R.not(path)) return U.history.push(C.ROUTE_PATH_HOME);

    changeRouteRoutine({
      path,
    });
  }, [location, changeRouteRoutine]);

  return (
    <Routes>
      <Route path={C.ROUTE_PATH_LOGIN} element={<Login />} />
      <Route path='/' element={<ProtectedRoute loggedIn={loggedIn} />}>
        <Route index={true} element={<Board />} />
      </Route>
      {/* This route 404 must be last in the routes list */}
      <Route index={true} path={C.ROUTE_PATH_NOT_FOUND} element={<NotFound />} />
    </Routes>
  );
};

const mapStateToProps = state => createStructuredSelector({
  loggedIn: makeSelectLoggedIn(state),
});

export default connect(mapStateToProps, {
  loginRoutine,
  changeRouteRoutine,
})(CustomRoutes);

export {
  routes,
};
